import { Card } from '@repo/shadcn';

import { CsvExportIcon, PdfExportIcon } from '@components/icons';
import { HeaderBreadcrumb } from '@components/ui';
import { DataTable } from '@components/ui/data.table/data-table';
import PaginationComponent from '@components/ui/pagination';

import { DEFAULT_PAGE_LIMIT } from '@/constants';
import { useUrlPagination } from '@/hooks';
import { supplierReportColumns } from '@/modules/reports/supplier/supplier-report.column';
import { useSupplierReport } from '@/modules/reports/supplier/supplier-report.hook';

export const ReportSupplier = () => {
    const { page, setCurrentPage } = useUrlPagination();
    const {
        handleExportToPdf,
        handleExportToCSV,
        isFetching,
        isLoading,
        data,
        isError,
    } = useSupplierReport();

    const renderTable = () => {
        if (isError) {
            return <div>Something went wrong</div>;
        }

        return (
            <>
                <DataTable
                    isLoading={isLoading || isFetching}
                    data={data?.data || []}
                    columns={supplierReportColumns}
                />
                <p className="mt-3 flex w-full items-center px-4 text-right font-semibold">
                    Total Found : {data?.pagination?.total_items}
                </p>
                <PaginationComponent
                    showTotalItems
                    totalItems={data?.pagination?.total_items || 0}
                    itemsPerPage={data?.pagination?.limit || DEFAULT_PAGE_LIMIT}
                    initialPage={page}
                    onPageChange={(p) => {
                        setCurrentPage(p);
                    }}
                />
            </>
        );
    };

    return (
        <Card className={'space-y-4 p-4'}>
            <div className={'flex items-start justify-between'}>
                <HeaderBreadcrumb
                    showHomeLink={true}
                    items={[{ label: 'Supplier Report' }]}
                />
                <div className={'flex items-center gap-4'}>
                    <div className={'flex items-center gap-4'}>
                        <button
                            type={'button'}
                            className={'scale-[1.2]'}
                            onClick={handleExportToPdf}
                        >
                            <PdfExportIcon />
                        </button>
                        <button
                            type={'button'}
                            className={''}
                            onClick={handleExportToCSV}
                        >
                            <CsvExportIcon />
                        </button>
                    </div>
                </div>
            </div>

            <h2 className={'text-xl font-medium'}>Supplier Reports</h2>

            <div>Filters --- Search</div>

            <Card>{renderTable()}</Card>
        </Card>
    );
};

ReportSupplier.displayName = 'ReportSupplier';
